const CONSTITUENCY = {
	ELETORAL_DIVISION_CONSTITUENCY: 'electoral_division_constituency',
	ELETORAL_DIVISION_CONSTITUENCY_CREATE: 'electoral_division_constituency_create',
	ELETORAL_DIVISION_CONSTITUENCY_SEARCH: 'electoral_division_constituency_search',
	ELETORAL_DIVISION_CONSTITUENCY_FILTER: 'electoral_division_constituency_filter',
	ELETORAL_DIVISION_CONSTITUENCY_DELETE: 'electoral_division_constituency_delete',
} as const;

const LGA = {
	ELETORAL_DIVISION_LGA: 'electoral_division_lga',
} as const;

const WARD = {
	ELETORAL_DIVISION_WARD: 'electoral_division_ward',
} as const;

const PU = {
	ELETORAL_DIVISION_PU: 'electoral_division_polling_unit',
} as const;

export const ACTIONS_ELECTORAL_DIVISION = {
	ELECTORAL_DIVISION: 'electoral_division',
	// new
	ZONEVIEW: 'zone_view',
	STATEVIEW: 'state_view',
	CONSTITUENCYVIEW: 'constituency_view',
	LGAVIEW: 'lga_view',
	POLLINGUNITVIEW: 'polling_unit_view',
	/**
	 * api.core `ActionKeys.PollingUnitEdit`. Gates the polling-unit writes, including the
	 * coordinate PATCH behind the map's "Place on map" / "Edit location".
	 */
	POLLINGUNITEDIT: 'polling_unit_edit',
	WARDVIEW: 'ward_view',
	IMPORT_VOTERS: 'import_voters',
	// new-end
	...CONSTITUENCY,
	...LGA,
	...WARD,
	...PU,
} as const;
